/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.contacts.init());

App.contacts = {
  init() {
    return $(document)
      .off("click", ".js-request-contact-updates", App.contacts.request_updates)
      .on("click", ".js-request-contact-updates", App.contacts.request_updates)

      .off("click", ".js-destroy-contact-memberships", App.contacts.destroy_memberships)
      .on("click", ".js-destroy-contact-memberships", App.contacts.destroy_memberships)

      .off("click", ".js-remove-multiple-from-group", App.contacts.destroy_groupings)
      .on("click", ".js-remove-multiple-from-group", App.contacts.destroy_groupings)

      .off("click", ".js-email-toggle", App.contacts.toggle_email_required)
      .on("click", ".js-email-toggle", App.contacts.toggle_email_required)

      .off("click", ".js-sms-toggle", App.contacts.toggle_mobile_required)
      .on("click", ".js-sms-toggle", App.contacts.toggle_mobile_required)

      .off("click", ".js-email-toggle", App.contacts.submit_form)
      .on("click", ".js-email-toggle", App.contacts.submit_form)

      .off("click", ".js-sms-toggle", App.contacts.submit_form)
      .on("click", ".js-sms-toggle", App.contacts.submit_form)

      .off("blur", ".js-contact-email", App.contacts.show_error_on_email_if_blank)
      .on("blur", ".js-contact-email", App.contacts.show_error_on_email_if_blank)

      .off("blur", ".js-contact-mobile", App.contacts.show_error_on_mobile_if_blank)
      .on("blur", ".js-contact-mobile", App.contacts.show_error_on_mobile_if_blank)

      .off("submit", ".edit_contact", App.contacts.clear_errors)
      .on("submit", ".edit_contact", App.contacts.clear_errors)

      .off("click", ".js-contact-action", App.contacts.show_actions)
      .on("click", ".js-contact-action", App.contacts.show_actions)

      .off("click", ".js-contact-remove-from-group", App.contacts.remove_from_group)
      .on("click", ".js-contact-remove-from-group", App.contacts.remove_from_group)

      .off("click", ".js-contact-delete-from-account", App.contacts.delete_from_account)
      .on("click", ".js-contact-delete-from-account", App.contacts.delete_from_account);
  },

  scroll_to_top() {
    // $(".js-content-main").scrollTo(0, $(".js-contact-index").position().top)
    return $(".js-content-main").scrollTop(0, 0);
  },

  submit_form(e) {
    return $(".edit_contact").submit();
  },

  request_updates(e) {
    e.preventDefault();
    const membership_ids = App.select_multiple.get_selected_contact_membership_ids();
    // console.log "in request_updates, membership_ids: ", membership_ids

    return $.post(
      $(this).attr("href"),
      { contact_membership_ids: membership_ids }
    );
  },

  destroy_memberships(e) {
    e.preventDefault();

    const membership_ids = App.select_multiple.get_selected_contact_membership_ids();

    const pluralized = membership_ids.length === 1 ?
                   " contact"
                 :
                   " contacts";

    if (membership_ids[0]) {
      const $a = $(this);
      return swal({
        title: "Are you sure?",
        text: "This will delete " + membership_ids.length + pluralized + " from your entire account.",
        type: "warning",
        showCancelButton: true
      },
      confirmed => {
        if (confirmed) {
          let my_href =  window.location.origin + "/contact_memberships/destroy_multiple";
          my_href += "?" + $.param({contact_membership_ids: membership_ids});
          $a.attr("href", my_href);

          return $.ajax({
            url: my_href,
            method: "DELETE",
            dataType: "script"
          });
        }
      });
    }
  },

  destroy_groupings(e) {
    e.preventDefault();

    const membership_ids = App.select_multiple.get_selected_contact_membership_ids();

    const pluralized = membership_ids.length === 1 ?
                   " contact"
                 :
                   " contacts";

    if (membership_ids[0]) {
      const $a = $(this);
      return swal({
        title: "Are you sure?",
        text: "This will remove " + membership_ids.length + pluralized + " from this group.",
        type: "warning",
        showCancelButton: true
      },
      confirmed => {
        if (confirmed) {
          const my_href = window.location.origin + "/contact_membership_groupings/destroy_multiple" +
                    "?" + $.param({contact_membership_ids: membership_ids}) +
                    `&group_id=${App.groups.current_id()}`;

          $a.attr("href", my_href);

          return $.ajax({
            url: my_href,
            method: "DELETE",
            dataType: "script"
          });
        }
      });
    }
  },

  toggle_email_required(e) {
    let email_on = false;

    $(".js-email-toggle").each(function(i) {
      if ($(this).prop("checked")) {
        return email_on = true;
      }
    });

    if (email_on === true) {
      return $(".js-contact-email").prop("required", "required");
    } else {
      return $(".js-contact-email").removeAttr("required");
    }
  },

  toggle_mobile_required(e) {
    let sms_on = false;

    $(".js-sms-toggle").each(function(i) {
      if ($(this).prop("checked")) {
        return sms_on = true;
      }
    });

    if (sms_on === true) {
      return $(".js-contact-mobile").prop("required", "required");
    } else {
      return $(".js-contact-mobile").removeAttr("required");
    }
  },

  show_error_on_email_if_blank(e) {
    if (($(".js-contact-email").val() === "") && $(".js-contact-email").prop("required")) {
      $(".js-contact-email").addClass("error-field");
      $(".js-email-update-toggle").addClass("error-field");
      return $(".email-error-text").show();
    }
  },

  show_error_on_mobile_if_blank(e) {
    if (($(".js-contact-mobile").val() === "") && $(".js-contact-mobile").prop("required")) {
      $(".js-contact-mobile").addClass("error-field");
      $(".js-sms-update-toggle").addClass("error-field");
      return $(".sms-error-text").show();
    }
  },

  clear_errors(e) {
    $(".js-email-update-toggle").removeClass("error-field");
    $(".js-contact-email").removeClass("error-field");
    $(".js-sms-update-toggle").removeClass("error-field");
    $(".js-contact-mobile").removeClass("error-field");
    return $(".email-error-text").hide();
  },

  show_actions(e) {
    e.preventDefault();
    const $this = $(this);
    const name = $this.data("recipient-name");

    return swal({
      title: "Remove or Delete?",
      text: `\
<p>Remove ${name} from this group, or delete them entirely?</p> \
<br> \
<div class='btn btn-primary js-contact-remove-from-group' data-path='${$this.data("remove-path")}'>Remove from this group</div> \
<br/><br/> \
<div class='btn btn-danger js-contact-delete-from-account' data-path='${$this.data("destroy-path")}'>Delete from entire account</div> \
<br/>\
`,
      type: "warning",
      showCancelButton: true,
      showConfirmButton: false,
      html: true
    });
  },

  remove_from_group(e) {
    e.preventDefault();
    return $.ajax({
      url: $(this).data("path"),
      method: "POST",
      dataType: "script"
    });
  },

  delete_from_account(e) {
    e.preventDefault();
    return $.ajax({
      url: $(this).data("path"),
      method: "DELETE",
      dataType: "script"
    });
  }
};
